<div class="profile-notification-blocks">
    <div class="wpee-notification-block-wrap">
        <ul class="wpee-notification-links">
            <!-- <li class="wpee-menu ">
                <a  (click)="viewed_tab('Message')">
                    <i class="fa fa-smile-o"></i>Winks </a>
            </li> -->
            <li class="wpee-menu ">
                <a  (click)="viewed_tab('Message')">
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                    <span
                        class="wpee-count-num">{{total_notification}}</span>
                </a>
            </li>
            <li class="wpee-menu ">
                <a  (click)="viewed_tab('Friends')">
                    <fa-icon [icon]="fauser"></fa-icon>
                    <span
                    class="wpee-count-num">{{total_friendrequest}}</span>
                </a>
            </li>

            <li class="wpee-menu " >
                <a  (click)="viewed_tab('settings')"><fa-icon [icon]="faSettings"></fa-icon></a>
            </li>

            <li class="wpee-menu wpee-others">
                <a><fa-icon [icon]="famore"></fa-icon><span>Others</span>
                </a>
                <ul class="wpee-sub-menu no-list">
                    <li class="wpee-menu ">
                        <a  (click)="viewed_tab('viewed')">
                            <i class="fa fa-eye"></i>
                            <span>I Viewed / Viewed Me</span>
                        </a>
                    </li>
                    <li class="wpee-menu ">
                        <a  (click)="viewed_tab('edit_form')">
                            <i class="fa fa-pencil-square-o"></i>
                            <span>Edit Profile</span>
                        </a>
                    </li>
                    
                </ul>
            </li>
        </ul>
    </div>
</div>